import styled from "styled-components";

export const CarPlateStyled = styled.div`
  display: flex;
  align-items: center;

  border: #353a50 solid 1px;
  border-radius: 15px;
  font-size: 0.9em;
  padding: 0 3px;
  opacity: 0.8;

  > div {
    padding: 0 3px;
  }

  > div:first-child {
    border-left: solid 1px #5d6173;
  }
`;
